export default {
  'upcoming-appointments': 'Anstehende Termine',

  // Appointment
  appointment: 'Termin',
  appointments: 'Termine',
  'appointment-details': 'Termindetails | {appointmentType}',
  'appointments.empty': 'Sie haben noch keine Termine gebucht.',
  'appointments-requested.empty': 'Sie haben noch keine Termine angefragt.',
  'appointments-past.empty': 'Keine vergangen Termine vorhanden',

  'appointment.group-appointment': 'Gruppentermin',
  'appointment.group-appointment.description':
    'Bei dem gebuchten Termin handelt es sich um einen Gruppentermin.',
  'appointment.group-appointment.quota': 'Es sind {count} / {quota} Slots gebucht.',

  'appointment.history': 'Historie',
  'appointment.history.sub-title': 'Historie',
  'appointment.history.more': 'Mehr anzeigen',

  'appointment.history.event.booked.booked': 'Der Termin wurde gebucht.',
  'appointment.history.event.booked.update': 'Dieser Termin wurde umgebucht.',
  'appointment.history.event.cancelled': 'Dieser Termin wurde storniert.',
  'appointment.history.event.counter-request-submitted': 'Eine Gegenanfrage wurde versendet.',
  'appointment.history.event.finished': 'Der Termin ist abgeschlossen.',
  'appointment.history.event.missed': 'Es scheint, dass Sie diesen Termin verpasst haben.',
  'appointment.history.event.ongoing': 'Der Termin im Gange.',
  'appointment.history.event.proposals-rejected.booked': 'Die Terminvorschläge wurden abgelehnt.',
  'appointment.history.event.proposals-rejected.update':
    'Die Terminvorschläge für die Umbuchung wurden abgelehnt.',
  'appointment.history.event.proposals-accepted': 'Sie haben diesen Termin angenommen.',
  'appointment.history.event.proposals-received': 'Vorschlag erhalten.',
  'appointment.history.event.requested.book': 'Ihre Buchung wurde angefordert.',
  'appointment.history.event.requested.update': 'Ihre Terminänderung wurde angefordert.',
  'appointment.history.event.request-approved': 'Die Terminanfrage wurde bestätigt.',
  'appointment.history.event.request-rejected': 'Die Terminanfrage wurde abgelehnt.',
  'appointment.history.event.reserved': 'Der Termin ist reserviert.',
  'appointment.history.event.reassigned':
    'Ihre Terminanfrage wurde von der Einrichtung angepasst und erneut gestellt.',

  'appointment.cancellation': 'Terminstornierung',
  'appointment.cancellation.description': 'Dieser Termin wurde storniert.',
  'appointment.cancellation.no-reasons': 'Kein Stornierungsgrund angegeben.',
  'appointment.cancellation.reasons': 'Grund: {reason}',

  'appointment.archiving': 'Terminarchivierung',
  'appointment.archiving.description': 'Dieser Termin wurde archiviert.',

  'appointment-details.empty': 'Wählen Sie einen Termin aus der Liste aus, um diesen anzusehen',
  'appointment-cancel': 'Termin stornieren',
  'appointment-cancel.ishmed-tooltip':
    'Das Verschieben oder Stornieren dieses Termins ist nur telefonisch möglich. Bitte kontaktieren Sie die Klinik.',
  'appointment-edit': 'Bearbeiten',
  'appointment-type': 'Termin-Typ',
  'appointment.upload-document': 'Dokument hochladen',
  'appointment.patient-info': 'Informationen zum Patienten',
  'appointment.clinic-info': 'Klinik Informationen',
  'appointments.load-more': 'Mehr anzeigen',

  cancelled: 'Storniert',
  'appointment.cancelled': 'Storniert: {reasons}',
  'appointment.cancelled.no-reason': 'Kein Stornierungsgrund angegeben.',

  // Proposal
  'appointment.proposal': 'Terminvorschläge',
  'appointment.proposal.accept.title': 'Terminvorschlag akzeptieren',
  'appointment.proposal.accept.description':
    'Sie haben den Terminvorschlag am {date} ausgewählt. Möchten Sie diesen bestätigen?',
  'appointment.proposal.accept': 'Akzeptieren',
  'appointment.proposal.accept.success': 'Der Termin wurde erfolgreich gebucht',
  'notification.error': 'Ein unerwarteter Fehler ist aufgetreten',
  'appointment.proposal.reject-all': 'Ich kann keinen dieser Termine wahrnehmen',
  'appointment.proposal.description':
    'Sie haben eine Liste von Terminvorschlägen von der Klinik erhalten. Bitte wählen Sie Ihren gewünschten Termin aus, um diesen zu bestätigen.',
  'appointment-proposal.reject.title': 'Terminvorschläge ablehnen',
  'appointment-proposal.reject': 'Ablehnen',
  'appointment-proposal.reject.info': 'Terminvorschläge wurden abgelehnt',
  'appointment-proposal.reject.description':
    'Sind Sie sicher, dass Sie alle Terminvorschläge ablehnen möchten?',

  'success.appointment-booked': 'Termin erfolgreich gebucht',

  'appointment-successful.appointment-overview': 'Zur Terminübersicht',
  'appointment-successful.add-google-calendar': 'Zu Google Kalender hinzufügen',
  'appointment-successful.add-google-calendar.short': 'Zu Google Kalender hinzufügen',
  'appointment-successful.add-ical-calendar.short': 'Zu Kalender hinzufügen',
  'appointment.route': 'Route anzeigen',

  // Phone appointment
  'phone-appointment': 'Telefonsprechstunde',
  'phone-appointment.text':
    'Sie sind dabei, eine Telefonsprechstunde zu buchen. Alle weiteren Informationen erhalten Sie, nachdem die Terminbuchung abgeschlossen wurde.',
  'phone-appointment.external.default-text':
    'Für die Telefonsprechstunde erhalten Sie eine separate E-Mail.',

  // Video appointment
  'video-appointment': 'Videosprechstunde',
  'video-appointment.external.default-text':
    'Für die Videosprechstunde erhalten Sie eine separate E-Mail.',
  'video-appointment.text':
    'Sie sind dabei, eine Videosprechstunde zu buchen. Alle weiteren Informationen erhalten Sie, nachdem die Terminbuchung abgeschlossen wurde.',
  'video-appointment.description':
    'Hier können Sie Ihre Videosprechstunde starten. Sie werden auf eine andere Seite weitergeleitet. Ihr Videoanruf beginnt, sobald Ihr Arzt ihn gestartet hat.',
  'video-appointment.start': 'Videosprechstunde Starten',

  //In person appointment
  'in-person-appointment': 'Termin vor Ort',

  // Tasks
  'appointment-tasks.title': 'Aufgaben',

  'appointment-tasks.before': 'Vor Termin',
  'appointment-tasks.after': 'Nach Termin',
  'appointment-tasks.while': 'Während Termin',

  'appointment-tasks.upload-document': 'Dokument teilen',
  'appointment-tasks.share': 'Ausgewählte Dokumente hochladen',
  'appointment-tasks.upload-document.header':
    'Klicken oder ziehen Sie die Datei zum Hochladen in diesen Bereich',
  'appointment-tasks.upload-document.description':
    'Ausgewählte Dateien werden verschlüsselt übertragen und können bei Ihrem Termin eingesehen werden.',

  'appointment.add-event.summary': 'Termininformation',
  'appointment.add-event.link': 'In Google Kalender anzeigen',
  'appointment.add-event.success': 'Termin wurde erfolgreich zum Kalender hinzugefügt',
  'appointment.add-event.fail': 'Termin konnte nicht zu Ihrem Kalender hinzugefügt werden',
  'appointment.add-event.ical': 'Zum Kalender hinzufügen',

  'appointment.rebooking': 'Terminumbuchung',
  'appointment.reasons-for-rebooking': 'Achtung: Dieser Termin wurde umgebucht!',
  'appointment.rebooking.latest-date': 'Neues Datum: {date}',

  'appointment.not-verified': 'Nicht verifiziert',
  'appointment.not-verified.description':
    'Dieser Termin wird in Kürze gelöscht, falls Sie Ihr Konto nicht bestätigen.',
  'appointment-request.not-verified': 'Nicht verifiziert',
  'appointment-request.not-verified.description':
    'Diese Anfrage wird in Kürze gelöscht, falls Sie Ihr Konto nicht bestätigen.',

  'cancel-appointment.title': 'Terminstornierung',
  'cancel-appointment.success': 'Ihr Termin am {date} wurde storniert',
  'cancel-appointment-request.success': 'Ihre Terminanfrage wurde storniert',
  'cancel-appointment.reason': 'Bitte sagen Sie uns, warum Sie Ihren Termin stornieren möchten',

  'appointment.booked-at': 'Termin gebucht am {bookedAt}',
  'appointment-request.booked-at': 'Terminanfrage gestellt am {bookedAt}',

  'appointment.route.short': 'Route',
  'appointment.calendar.short': 'Kalender',
  'appointment.google-calendar.short': 'Kalender',
  'appointment.qr-code.short': 'QR-Code',
  'appointment.qr-code': 'QR-Code anzeigen',
};
